var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXSignGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stop",
    d: "M77.536,129.713a1.6,1.6,0,1,1-2.264,2.263l-5.264-5.263-5.272,5.263a1.613,1.613,0,0,1-1.136.472,1.6,1.6,0,0,1-1.128-2.735l5.272-5.263-5.272-5.271a1.6,1.6,0,0,1,2.264-2.263l5.272,5.271,5.264-5.271a1.6,1.6,0,0,1,2.264,2.263l-5.264,5.271Z",
    transform: "translate(-62.004 -116.447)",
    fill: "#A1A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSignGrey);
export default __webpack_public_path__ + "static/media/XSignGrey.4345c6a65d490be18531017134c8dcb4.svg";
export { ForwardRef as ReactComponent };